import { Flame } from "lucide-react";

export default function Marquee({ items = [] }) {
  const list = items.length ? items : ["Cajun", "Creole", "Seafood", "Southern"];
  const doubled = [...list, ...list, ...list, ...list];
  return (
    <div className="overflow-hidden border-y border-brass/10 bg-parchment py-5" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-10">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-serif text-2xl italic text-ink2/60">{item}</span>
            <Flame size={14} className="text-flame/70" />
          </span>
        ))}
      </div>
    </div>
  );
}
